import {Component, Input, OnInit} from "@angular/core";
import {edsEnvConfiguration} from "../../../environments/edsEnvConfiguration";
import { select } from "@angular-redux/store";
import {appProjectInfo} from "../../../info.app";
import {Observable} from "rxjs";
import {support_to_url} from "../../common/utils";
import {AnalyticsActions} from "../../Redux/Actions/analytics.actions";
import {ActionsService} from "../../Redux/Actions/actions.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "edsng-app-info",
  templateUrl: "./app-info.component.html",
  styleUrls: ["./app-info.component.css"]
})
export class AppInfoComponent implements OnInit {
  @select(['appCatalog', 'loading']) loading$: Observable<boolean>;

  @Input() showVersion: boolean = false;

  public appInfo;
  public env;
  public showFooter: boolean= false;

  constructor(private act: ActionsService, public translate: TranslateService) {
    this.appInfo = appProjectInfo;
    this.env = edsEnvConfiguration;
  }

  ngOnInit() {
    this.showFooter = !window.location.hash.includes("hackathon");
  }

  getVersionString(): string {
    return (
      this.appInfo.version +
      (this.appInfo.verName && this.appInfo.verName !== ""
        ? " " + this.appInfo.verName
        : "") +
      (this.appInfo.build
        ? " build: " + this.appInfo.build
        : "") +
      (!edsEnvConfiguration.production ? " (Dev)" : "")
    );
  }

  getYearString(): string {
    return `${ new Date().getFullYear() }`;
  }

  showPage(pageId: string) {
    this.act.sendAction(AnalyticsActions.sendAnalyticsEvent('support_request', pageId, {details: pageId}));
    window.open(support_to_url(pageId, this.translate.currentLang), '_blank');
  }
}
